

const Spinner = () => {
    return(
        <div>
            <div className="custom-loader"></div>
        </div>
    )
}
export default Spinner;